import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const s3BucketsManagerPlugin = createPlugin({
  id: 's3-buckets-manager',
  routes: {
    root: rootRouteRef,
  },
});

export const S3BucketsManagerPage = s3BucketsManagerPlugin.provide(
  createRoutableExtension({
    name: 'S3BucketsManagerPage',
    component: () =>
      import('./components/S3BucketsManagerPage').then(m => m.S3BucketsManagerPageComponent),
    mountPoint: rootRouteRef,
  }),
);
